import { Typography } from 'components'

import { HighlightCard } from './HighlightCard'

const HighlightsSection = () => (
	<section class='mb-8'>
		<Typography
			class='mb-5'
			color='text-black-100'
			text='Highlights'
			variant='h4'
		/>
		<div class='mt-4 grid grid-cols-1 gap-5 xl:grid-cols-2'>
			<HighlightCard
				color='product'
				description="Stay up-to-date with Codigo's latest news and update."
				href='https://twitter.com/CodigoPlatform'
				hrefAriaLabel='Follow us on X'
				title=' Be part of our X community'
			/>
			<HighlightCard
				color='orange'
				description="Get realtime support from Codigo's community and team."
				href='https://discord.gg/8XHQGS832k'
				hrefAriaLabel='Go to our Discord community'
				title='Welcome to our Discord community'
			/>
		</div>
	</section>
)

export { HighlightsSection }
